export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ViewerComponent.vue?vue&type=template&id=6b3c5806&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/viewer/components/ViewerComponent.vue?vue&type=template&id=6b3c5806&scoped=true&
// module id = 301
// module chunks = 0